import React, { useState, useEffect, useCallback } from 'react';
import { Loader2 } from 'lucide-react';
import InteractiveCalendar from '../clinic/InteractiveCalendar';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminCalendarHub({ authFetch }) {
  const [appointments, setAppointments] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await authFetch(`${API}/clinic/appointments`);
      const data = await res.json();
      setAppointments(data.appointments || data || []);
    } catch { setAppointments([]); }
  }, [authFetch]);

  useEffect(() => { load(); }, [load]);

  const createAppointment = async (payload) => {
    setSaving(true);
    try {
      const res = await authFetch(`${API}/clinic/appointments`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
      if (res.ok) { await load(); return true; }
    } catch {}
    finally { setSaving(false); }
    return false;
  };

  const updateAppointment = async (id, updates) => {
    setSaving(true);
    try {
      const res = await authFetch(`${API}/clinic/appointments/${id}`, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(updates) });
      if (res.ok) { await load(); return true; }
    } catch {}
    finally { setSaving(false); }
    return false;
  };

  const deleteAppointment = async (id) => {
    setSaving(true);
    try {
      const res = await authFetch(`${API}/clinic/appointments/${id}`, { method: 'DELETE' });
      if (res.ok) { await load(); return true; }
    } catch {}
    finally { setSaving(false); }
    return false;
  };

  if (appointments === null) {
    return <div className="flex items-center gap-2 p-8 text-gray-400" data-testid="admin-calendar-loading"><Loader2 className="w-5 h-5 animate-spin" /> Cargando calendario de citas…</div>;
  }

  return (
    <div data-testid="admin-calendar-hub">
      <InteractiveCalendar
        appointments={appointments}
        onCreate={createAppointment}
        onUpdate={updateAppointment}
        onDelete={deleteAppointment}
        canEdit
        saving={saving}
        apiFetch={authFetch}
        subtitle="Calendario Neuralia369 · Citas clínica + CRM · Aynara"
      />
    </div>
  );
}
